// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-box[data-v-0336a6c0] {\n  width: 77%;\n}\n.c_radio .c_row-item[data-v-0336a6c0] {\n  -webkit-box-align: unset;\n      -ms-flex-align: unset;\n          align-items: unset;\n}\n.c_radio .c_row-item.on[data-v-0336a6c0] {\n  display: block;\n}\n[data-v-0336a6c0] .el-date-editor {\n  width: 100%;\n}\n[data-v-0336a6c0] .c_radio .el-radio {\n  margin: 5px 25px 5px 0;\n}", ""]);
// Exports
module.exports = exports;
